import { Tooltip } from "flowbite-react";
import { useState } from "react";
import { Popup } from "../../../components/pop-up";
import { IconButton } from "../../../components/buttons";

export function ToggleUserStatus({ data, onConfirm }) {
  const [openModal, setOpenModal] = useState();
  return (
    <>
      <Tooltip
        content={data.is_active ? "Deactivate User" : "Activate User"}
        placement="bottom"
      >
        <IconButton onClick={() => setOpenModal("pop-up")}>
          {data?.is_active ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
              />
            </svg>
          ) : (
            <svg
              onClick={() => setOpenModal("pop-up")}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
              />
            </svg>
          )}
        </IconButton>
      </Tooltip>
      <Popup
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`${
                data.is_active ? "stroke-red-600" : "stroke-green-500"
              } mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to{" "}
              {data.is_active ? "deactivate" : "activate"}{" "}
              <b className={data.is_active ? "text-red-500" : "text-green-500"}>
                {data.first_name + " " + data.last_name}
              </b>
              ?
            </h3>
          </>
        }
        cancelText="No, cancel"
        confirmText={`Yes, ${data.is_active ? "deactivate" : "activate"}`}
        confirmClass={
          data.is_active ? "bg-red-600 text-white" : "bg-green-500 text-white"
        }
        modalState={[openModal, setOpenModal]}
        onConfirm={() => {
          onConfirm && onConfirm(data);
          setOpenModal(undefined);
        }}
      />
    </>
  );
}
